import React from "react";
import { NavLink } from "react-router-dom";
import PageHero from "../components/PageHero";
import ImageGallery from "../components/ImageGallery";

function RaisedTabs() {
  return (
    <div className="category-tabs">
      <NavLink end to="/raised-flooring">
        Overview
      </NavLink>
      <NavLink to="/raised-flooring/specifications">Specifications</NavLink>
      <NavLink to="/raised-flooring/projects">Projects</NavLink>
    </div>
  );
}

function RaisedFlooringOverview() {
  return (
    <div className="page">
      <PageHero
        title="Raised Flooring"
        subtitle="Access flooring for data centres, control rooms and premium offices."
        imagePlaceholder="Access Floor Panels"
      />
      <RaisedTabs />

      <section className="section">
        <h2>Where It’s Used</h2>
        <div className="two-column">
          <ul className="list">
            <li>Data centres & server rooms</li>
            <li>Network & control rooms</li>
            <li>Trading floors & offices</li>
            <li>Telecom & IT facilities</li>
          </ul>
          <p className="muted">
            Raised floors create an accessible plenum for power, data and HVAC
            distribution.
          </p>
        </div>
      </section>
    </div>
  );
}

export function RaisedFlooringSpecs() {
  return (
    <div className="page">
      <PageHero
        title="Raised Flooring – Specifications"
        subtitle="Panel types, loading classes and finish options."
        imagePlaceholder="Pedestal + Stringer Detail"
      />
      <RaisedTabs />

      <section className="section">
        <h2>Typical System</h2>
        <div className="spec-grid">
          <div>
            <h3>Panels</h3>
            <p>Steel or calcium sulphate core in 600 × 600 mm size.</p>
          </div>
          <div>
            <h3>Understructure</h3>
            <p>Adjustable pedestals with optional stringers.</p>
          </div>
          <div>
            <h3>Top Finishes</h3>
            <p>HPL, vinyl, carpet or anti-static finishes.</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export function RaisedFlooringProjects() {
  const galleryItems = [
    { label: "Data Centre Aisles" },
    { label: "Cable Management" },
    { label: "Control Room Layout" },
    { label: "Anti-static Finish" },
    { label: "Open Office Floor" }
  ];

  return (
    <div className="page">
      <PageHero
        title="Raised Flooring – Projects"
        subtitle="Reference installations in IT, BFSI and industrial control rooms."
        imagePlaceholder="Flooring Installations"
      />
      <RaisedTabs />

      <section className="section">
        <h2>Sample Use Cases</h2>
        <div className="card-grid">
          <div className="card">
            <h3>IT Data Centre</h3>
            <p>Heavy-duty system with perforated tiles for cold aisle design.</p>
          </div>
          <div className="card">
            <h3>Trading Floor</h3>
            <p>Medium load system with carpet tiles for comfort & acoustics.</p>
          </div>
          <div className="card">
            <h3>Control Room</h3>
            <p>Anti-static panels with access for cabling & monitoring.</p>
          </div>
        </div>
      </section>

      <section className="section section-highlight">
        <h2>Project Gallery</h2>
        <p className="muted" style={{ marginBottom: "0.8rem" }}>
          Click to expand any flooring detail or installation photo.
        </p>

        <ImageGallery items={galleryItems} />
      </section>
    </div>
  );
}

export default RaisedFlooringOverview;
